






























































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { IChannel } from "@/@types/channels/channels";

import ChangeDeliteButtons from "../../buttons/change-delite-buttons.vue";
import QuickChangeForm from "@/components/forms/quick-change-form.vue";
import BSwitch from "../../app/switchs/b-switch.vue";
import StandartModal from "@/components/app/standart-modal.vue";

import {
  channelType,
  channelTypes,
  polarizations,
  audioStreamTypes,
  rfBroadcastTypes,
  ipBroadcastTypes,
  videoStreamTypes,
} from "@/config/channels/channel-types.config.json";

@Component({
  components: {
    StandartModal,
    "change-btn": ChangeDeliteButtons,
    BSwitch,
    QuickChangeForm,
  },
})
export default class FullChannelCard extends Vue {
  @Prop({ type: Object, default: null }) channel!: IChannel;
  @Prop({ type: Boolean, default: false }) restore!: boolean;

  quick_change_field = "";
  quick_change_scope: "data" | "root" = "data";

  get change_field_param(): string {
    if (!this.channel) return "";
    const source =
      this.quick_change_scope === "data" && this.channel.data
        ? this.channel.data
        : this.channel;
    const param = (source as unknown as Record<string, unknown>)[
      this.quick_change_field as string
    ];
    return param !== null && param !== undefined ? String(param) : "";
  }

  get videoStreamType(): string {
    const videoStreamType = videoStreamTypes.find(
      (t) => this.channel.data.videoStreamType == t.id
    );
    return videoStreamType ? videoStreamType.name : "UNKNOWN";
  }

  get polarization(): string {
    const polarizatopn = polarizations.find(
      (p) => this.channel.data.polarization == p.id
    );
    return polarizatopn ? polarizatopn.name : "UNKNOWN";
  }

  get audioStreamType(): string {
    const ast = audioStreamTypes.find(
      (a) => this.channel.data.audioStreamType == a.id
    );
    return ast ? ast.name : "UNKNOWN";
  }

  get rfBroadcastType(): {
    name: string;
    abriviate: string;
  } {
    const res = rfBroadcastTypes.find(
      (rf) => this.channel.data.rfBroadcastType == rf.id
    );
    return res
      ? { name: res.name, abriviate: res.abriviate }
      : { name: "UNKNOWN", abriviate: "UNKNOWN" };
  }

  get ipBroadcastType(): string {
    const rea = ipBroadcastTypes.find(
      (t) => this.channel.data.ipBroadcastType == t.id
    );
    return rea ? rea.name : "UNKNOWN";
  }

  get getType(): string {
    const type = channelTypes[this.channel.type - 1];
    return type ? type : "UNKNOWN";
  }

  get broadcastType(): string {
    const type = channelType.find((t) => this.channel.data.channelType == t.id);
    return type ? type.name : "UNKNOWN";
  }

  openQuickChange(
    id: string,
    field: string,
    scope: "data" | "root" = "data"
  ): void {
    this.quick_change_field = field;
    this.quick_change_scope = scope;
    this.$nextTick(() => this.$bvModal.show("quick-change-channel-param"));
  }

  updateChannel(id: string, lang: string, name: string): void {
    if (!this.channel) return;
    const source =
      this.quick_change_scope === "data" && this.channel.data
        ? this.channel.data
        : this.channel;
    const original = (source as unknown as Record<string, unknown>)[
      this.quick_change_field as string
    ];
    let value: unknown = name;
    if (typeof original === "number") {
      const num = Number(name);
      value = name === "" || isNaN(num) ? original : num;
    }
    const full = JSON.parse(JSON.stringify(this.channel)) as IChannel;
    if (this.quick_change_scope === "data" && full.data) {
      (full.data as unknown as Record<string, unknown>)[
        this.quick_change_field
      ] = value;
    } else {
      (full as unknown as Record<string, unknown>)[this.quick_change_field] =
        value;
    }
    this.$emit("updateChannel", full, id);
  }
}
